const COOKIE_NAME = 'auth_session';

export const setSessionCookie = (): void => {
    document.cookie = `${COOKIE_NAME}=1; path=/; SameSite=Strict`;
};

export const hasSessionCookie = (): boolean =>
    document.cookie.split('; ').some((c) => c.startsWith(`${COOKIE_NAME}=`));

export const clearSessionCookie = (): void => {
    document.cookie = `${COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};
